import { Component, OnInit, OnDestroy, Input, ElementRef } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppData } from "src/app/helpers/app-data";
import { Subscription, Subject, lastValueFrom } from "rxjs";
import { BaseServiceService } from "src/app/services/base-service.service";
import { ModalNotifyTypes } from "../modal-notify/modal-notify.component";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

declare var fabric: any;

@Component({
  selector: "app-notify-data",
  templateUrl: "./notify-data.component.html",
  styleUrl: "./notify-data.component.css",
})
export class NotifyDataComponent implements OnInit, OnDestroy {
  private currentUserIdSubscription: Subscription;
  private currentGrupoIdSubscription: Subscription;

  constructor(
    private baseService: BaseServiceService,
    private http: HttpClient,
    private elementRef: ElementRef,
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.procesoObj = new Proceso();
  }

  @Input() ActivityId?: string;
  @Input() reloadTables: boolean = false;
  idReceived: number;
  idReceivedGrupo: number;
  dialogComponentModalDestinatariosUsuario: any;
  dialogComponentGuardarDestinatarios: any;
  dialogComponentGuardarUsuarios: any;
  dialogComponentDestinatariosGuardados: any;
  dialogComponentEliminarUsuarios: any;
  dialogComponentUsuariosGuardados: any;
  botonProcesando = false;
  dtTriggerDestinatario: Subject<any> = new Subject<any>();
  destinatariosGrid = [];
  EmailDestinatario: string;
  receiverForm: FormGroup;
  submitted: boolean;
  procesoObj: Proceso;
  counterReceivers: number = 30;
  counterReceiversOrigin: number = 30;
  isGrupos: boolean = false;
  campo:any;
  usuariosExcluidos:any;
  
  columnasDestinatario = [{ title: "Usuario", data: "Email" }];

  dtOptionsDestinatarios: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 5,
    serverSide: false,
    processing: true,
    searching: true,
    ordering: true,
    data: this.destinatariosGrid,
    columns: this.columnasDestinatario,
    language: {
      url: "../../../assets/es-ES.json",
    },
    lengthMenu: [5], // Ocultar la opción de cambiar la cantidad de registros a mostrar
  };

  dtOptionsDestinatariosUsuario: DataTables.Settings = {};
  getUsuarios = ["Usuario", "GetDataTableUsuarioActivoFiltrado"];
  dtOptButtonsDestinatariosUsuario: any = [];
  dtInstanceDestinatariosUsuario: DataTables.Api;

  dtTableId: string;

  async ngOnInit() {
    
    this.usuariosExcluidos = this.destinatariosGrid.map((usuario) =>
      parseInt(usuario.Id)
    );

    this.receiverForm = this._formBuilder.group({
      EmailDestinatario: new FormControl("", [
        Validators.required,
        Validators.email,
        Validators.maxLength(100),
      ]),
    });

    this.currentUserIdSubscription = this.baseService.currentUserId.subscribe(
      (userId) => {
        this.idReceived = parseInt(userId);
      }
    );

    this.currentGrupoIdSubscription = this.baseService.currentIdGrupo.subscribe(
      (grupoId) => {
        this.idReceivedGrupo = parseInt(grupoId);
      }
    );

    if (this.route.snapshot.routeConfig?.path === "usuarios-permitidos") {
      this.isGrupos = true;
    }

    let dialog = document.querySelector(".modal-destinatarios-usuario");
    this.dialogComponentModalDestinatariosUsuario = new fabric["Dialog"](
      dialog
    );

    this.dtOptButtonsDestinatariosUsuario.push(
      {
        "button-id": "btnUnCheck",
        "button-icon": "ms-Icon--Checkbox",
        "conditional-data": [{ key: "field", value: "Email" }],
      },
      {
        "button-id": "btnCheck",
        "button-icon": "ms-Icon--CheckboxComposite",
        "button-hide": true,
        "conditional-data": [{ key: "field", value: "Email" }],
      }
    );

    let responseList = await lastValueFrom(
      this.http.get<any>(
        AppData.API_URL +
          "GrupoUsuario/ListUsuariosGrupo?Id=" +
          this.idReceivedGrupo
      )
    );
    console.log(responseList);
    
    if (responseList.Ok && responseList.Data.length > 0) {
      this.destinatariosGrid = responseList.Data;
      this.reloadDestinatarios();
      
    }   
  }

  ngAfterViewInit(): void {
    this.reloadDestinatarios();

    this.elementRef.nativeElement.addEventListener("click", (event) => {


      if (event.target.id === "btnDelete") {

        this.campo = event.target.getAttribute("data-field");

        this.abrirModalEliminarUsuario();
      }
    });
  }

  ngOnDestroy(): void {
    this.currentUserIdSubscription.unsubscribe();
    this.currentGrupoIdSubscription.unsubscribe();
  }

  ngOnChanges() {
    
    this.counterReceivers = this.counterReceiversOrigin;
    $("#stackReceivers").parent().css("color", "black");
    this.destinatariosGrid = [];
    this.obtenerPermisos();
  }
  eliminarUsuarioDataTable(campo: any) {
    
    for (var i = 0; i < this.destinatariosGrid.length; i++) {
      if (this.destinatariosGrid[i].Email.trim() == campo.trim()) {
        this.destinatariosGrid.splice(i, 1);
        this.counterReceivers++;
        //$('#stackReceivers').html(this.counterReceivers.toString());
        $("#stackReceivers").parent().css("color", "black");
      }
    }

    if (this.destinatariosGrid.length == 0) {
      $("#saveDestinatarios").prop("disabled", true);
    }

    $("#datatableDestinatarios").DataTable().destroy();
    this.dtOptionsDestinatarios.data = this.destinatariosGrid;
    this.dtTriggerDestinatario.next(this.dtOptionsDestinatarios);
  }
  gridLoaded(event: any) {
    this.dtTableId = event["tableId"];

    if (event["tableId"] == "datatableDestinatariosUsuario" && event["table"]) {
      this.dtInstanceDestinatariosUsuario = event["table"];
    }
  }

  customClick(event: any) {
    try {
      const campo = event["data-field"];
      const id = parseInt(event["data-id"]);
      this.dtTableId = event["table-id"];

      switch (this.dtTableId) {
        case "datatableDestinatariosUsuario":
          if (event["button-id"] == "btnCheck") {
            for (var i = 0; i < this.destinatariosGrid.length; i++) {
              if (this.destinatariosGrid[i].Email.trim() == campo.trim()) {
                this.destinatariosGrid.splice(i, 1);
                this.counterReceivers++;
                //$('#stackReceivers').html(this.counterReceivers.toString());
                $("#stackReceivers").parent().css("color", "black");
              }
            }

            if (this.destinatariosGrid.length == 0) {
              $("#saveDestinatarios").prop("disabled", true);
            }

            $("#datatableDestinatarios").DataTable().destroy();
            this.dtOptionsDestinatarios.data = this.destinatariosGrid;
            this.dtTriggerDestinatario.next(this.dtOptionsDestinatarios);

            event.event.srcElement.parentNode.children[
              "btnUnCheck"
            ].setAttribute("style", "display:block");
            event.event.srcElement.parentNode.children["btnCheck"].setAttribute(
              "style",
              "display:none"
            );
          } else if (event["button-id"] == "btnUnCheck") {
            let userFound = false;

            for (var i = 0; i < this.destinatariosGrid.length; i++) {
              if (this.destinatariosGrid[i].Email.trim() == campo.trim()) {
                userFound = true;
              }
            }

            if (!userFound) {
              if (this.destinatariosGrid.length < this.counterReceiversOrigin) {
                this.destinatariosGrid.push({ Email: campo, Id: id });

                this.counterReceivers--;
                //$('#stackReceivers').html(this.counterReceivers.toString());
                $("#stackReceivers")
                  .parent()
                  .css("color", this.counterReceivers == 0 ? "brown" : "black");
              } else {
                //$('#stackReceivers').html(this.counterReceivers.toString());
                $("#stackReceivers").parent().css("color", "brown");
              }
            }

            if (this.destinatariosGrid.length > 0) {
              $("#saveDestinatarios").prop("disabled", false);
            }

            $("#datatableDestinatarios").DataTable().destroy();
            this.dtOptionsDestinatarios.data = this.destinatariosGrid;
            this.dtOptionsDestinatarios.columns = [
              ...this.columnasDestinatario,
              {
                title: "Eliminar",
                data: "Email",
                orderable: false,
                render: (data: any, type: any, full: any) => {
                  // Inicializar botones existentes
                  let buttons = `
                    <button class="ms-CommandButton-button" data-field="${full.Email}" id="btnDelete">
                      <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Delete"></i></span>
                    </button>
                    `;

                  return buttons;
                },
              },
            ];

            this.dtTriggerDestinatario.next(this.dtOptionsDestinatarios);

            event.event.srcElement.parentNode.children[
              "btnUnCheck"
            ].setAttribute("style", "display:none");
            event.event.srcElement.parentNode.children["btnCheck"].setAttribute(
              "style",
              "display:block"
            );
          }

          break;
      }
    } catch (error) {
      console.error("Error al retornar evento datatable", error);
    }
  }

  AgregarEmail() {
    
    let userFound = false;

    for (var i = 0; i < this.destinatariosGrid.length; i++) {
      if (
        this.destinatariosGrid[i].Email.trim() == this.EmailDestinatario.trim()
      ) {
        $("#duplicateEmailError").html(
          "El destinatario " +
            this.EmailDestinatario +
            " ya se encuentra en la lista"
        );
        $("#duplicateEmailError").show();
        this.EmailDestinatario = "";
        userFound = true;

        setTimeout(() => {
          $("#duplicateEmailError").hide();
          $("#duplicateEmailError").html("");
        }, 5000);
      }
    }

    if (!userFound) {
      if (this.destinatariosGrid.length < this.counterReceiversOrigin) {
        this.destinatariosGrid.push({ Email: this.EmailDestinatario });
        this.counterReceivers--;
        //$('#stackReceivers').html(this.counterReceivers.toString());
        $("#stackReceivers")
          .parent()
          .css("color", this.counterReceivers == 0 ? "brown" : "black");
      } else {
        //$('#stackReceivers').html(this.counterReceivers.toString());
        $("#stackReceivers").parent().css("color", "brown");
      }

      if (this.destinatariosGrid.length > 0) {
        $("#saveDestinatarios").prop("disabled", false);
      }
      this.reloadDestinatarios();
      this.EmailDestinatario = "";
    }
  }

  abrirDataTableModal() {
    
    this.usuariosExcluidos = this.destinatariosGrid.map((usuario) =>
      parseInt(usuario.Id)
    );
    this.baseService.exportIdsExcluidosUsuarios(this.usuariosExcluidos);

    console.log(this.destinatariosGrid);
    
    var table = $("#datatableDestinatariosUsuario").DataTable();
    table.ajax.reload();
    this.dialogComponentModalDestinatariosUsuario.open();
  }

  closeDataTableModal() {
    this.dialogComponentModalDestinatariosUsuario.close();
  }

  abrirDataTableGrupos() {
    console.log("router");

    this.router.navigate(["home/grupos"]);
    this.dialogComponentModalDestinatariosUsuario.close();
  }

  reloadDestinatarios() {
    $("#datatableDestinatarios").DataTable().destroy();

    this.dtOptionsDestinatarios.data = this.destinatariosGrid;
    this.dtOptionsDestinatarios.columns = [
      ...this.columnasDestinatario,
      {
        title: "Eliminar",
        data: "Email",
        orderable: false,
        render: (data: any, type: any, full: any) => {
          // Inicializar botones existentes
          let buttons = `
            <button class="ms-CommandButton-button" data-field="${full.Email}" id="btnDelete">
              <span class="ms-CommandButton-icon ms-fontColor-themePrimary"><i class="ms-Icon ms-Icon--Delete"></i></span>
            </button>`;

          return buttons;
        },
      },
    ];

    this.dtTriggerDestinatario.next(this.dtOptionsDestinatarios);
  }

  async guardarDestinatariosNotificacion() {
    const emailsUsuarios =
      this.destinatariosGrid.length > 0
        ? this.destinatariosGrid.map((item) => item.Email).join(";") + ";"
        : "";
    // 

    this.procesoObj.IdProceso = this.idReceived;
    this.procesoObj.IdTarea = this.ActivityId;
    this.procesoObj.UsuariosPermitidos = emailsUsuarios;

    
    try {
      this.botonProcesando = true;
      const response = await this.baseService.create(
        "Proceso/ActualizarCorreosNotificaTarea",
        this.procesoObj
      );

      if (!response.Ok) {
        this.dialogComponentGuardarDestinatarios.close();

        let mensajeError = "<ul>";
        response.ValidationErrors.forEach((error: any) => {
          mensajeError += `<li>${error}</li>`;
        });
        mensajeError += "</ul>";

        this.baseService.triggerShowModal(
          "Error al actualizar permisos",
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
      } else {
        this.dialogComponentGuardarDestinatarios.close();
        this.abrirModalDestinatariosGuardados();
        this.botonProcesando = false;
      }
    } catch (error: any) {
      this.dialogComponentGuardarDestinatarios.close();

      let mensajeError = error.error.Error;

      this.baseService.triggerShowModal(
        "Error",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }

    console.log(this.procesoObj);
  }

  async guardarUsuariosGrupo() {
    const usuarios =
      this.destinatariosGrid.length > 0
        ? this.destinatariosGrid.map((item) => Number(item.Id)).join(";")
        : "";

    
    try {
      this.botonProcesando = true;
      const response = await this.baseService.create(
        `GrupoUsuario/UpdateUsuariosGrupo?Id=${this.idReceivedGrupo}`,
        { Usuarios: usuarios }
      );

      if (!response.Ok) {
        this.dialogComponentGuardarUsuarios.close();

        let mensajeError = "<ul>";
        response.ValidationErrors.forEach((error: any) => {
          mensajeError += `<li>${error}</li>`;
        });
        mensajeError += "</ul>";

        this.baseService.triggerShowModal(
          "Error al actualizar permisos",
          mensajeError,
          ModalNotifyTypes.Danger,
          false
        );
        this.botonProcesando = false;
      } else {
        this.abrirModalUsuariosGuardados();
        this.dialogComponentGuardarUsuarios.close();
        this.botonProcesando = false;
      }
    } catch (error: any) {
      this.dialogComponentGuardarDestinatarios.close();

      let mensajeError = error.error.Error;

      this.baseService.triggerShowModal(
        "Error",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }
  }

  async obtenerPermisos() {
    try {
      let responseList = null;
      this.botonProcesando = true;

      this.procesoObj.IdProceso = this.idReceived;
      this.procesoObj.IdTarea = this.ActivityId;

      responseList = await lastValueFrom(
        this.http.post<any>(
          AppData.API_URL + "Proceso/ListCorreosNotificaTarea",
          this.procesoObj
        )
      );

      if (responseList.Ok) {
        this.counterReceivers -= responseList.Data.length;
        $("#stackReceivers")
          .parent()
          .css("color", this.counterReceivers == 0 ? "brown" : "black");
        this.destinatariosGrid = responseList.Data.map((item: any) => {
          return {
            Email: item,
          };
        });

        this.botonProcesando = false;
      } else {
        this.botonProcesando = false;
      }

      this.reloadDestinatarios();
    } catch (error: any) {
      this.dialogComponentGuardarDestinatarios.close();

      let mensajeError = error.error.Error;

      this.baseService.triggerShowModal(
        "Error",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      this.botonProcesando = false;
    }
  }

  abrirModalDestinatarios() {
    const dialog = document.querySelector(".guardar-destinatarios");
    this.dialogComponentGuardarDestinatarios = new fabric["Dialog"](dialog);
    this.dialogComponentGuardarDestinatarios.open();
  }

  abrirModalUsuarios() {
    console.log(this.destinatariosGrid);
    
    const dialog = document.querySelector(".guardar-usuarios");
    this.dialogComponentEliminarUsuarios = new fabric["Dialog"](dialog);
    this.dialogComponentEliminarUsuarios.open();
  }

  abrirModalDestinatariosGuardados() {
    const dialogDestinatariosGuardados = document.querySelector(
      ".datatable-procesos"
    );
    this.dialogComponentDestinatariosGuardados = new fabric["Dialog"](
      dialogDestinatariosGuardados
    );
    this.dialogComponentDestinatariosGuardados.open();
  }
  abrirModalEliminarUsuario() {
    const dialogDestinatariosGuardados =
      document.querySelector(".eliminar-usuarios");
    this.dialogComponentDestinatariosGuardados = new fabric["Dialog"](
      dialogDestinatariosGuardados
    );
    this.dialogComponentDestinatariosGuardados.open();
  }
  abrirModalUsuariosGuardados() {
    const dialogUsuariosGuardados = document.querySelector(
      ".datatable-usuarios"
    );
    this.dialogComponentUsuariosGuardados = new fabric["Dialog"](
      dialogUsuariosGuardados
    );
    this.dialogComponentUsuariosGuardados.open();
  }

  enviarUsuariosPermitidosGrupo() {
    console.log("log");
  }
}

export class Proceso {
  IdProceso?: number;
  IdTarea?: string;
  UsuariosPermitidos: string;

  constructor() {
    this.IdProceso = undefined;
    this.IdTarea = undefined;
    this.UsuariosPermitidos = undefined;
  }
}
